<select name="range" [(ngModel)]="value" (ngModelChange)="onValueChange($event)">
  @for (item of items; track $index) {
    <option [value]="item.value" [disabled]="item.disabled">{{ item.text }}</option>
  }
</select>
